import { render, staticRenderFns } from "./BuyTapAdvance.vue?vue&type=template&id=31016695&scoped=true&"
import script from "./BuyTapAdvance.vue?vue&type=script&lang=js&"
export * from "./BuyTapAdvance.vue?vue&type=script&lang=js&"
import style0 from "./BuyTapAdvance.vue?vue&type=style&index=0&id=31016695&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31016695",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31016695')) {
      api.createRecord('31016695', component.options)
    } else {
      api.reload('31016695', component.options)
    }
    module.hot.accept("./BuyTapAdvance.vue?vue&type=template&id=31016695&scoped=true&", function () {
      api.rerender('31016695', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_price_versions/components/Buy/BuyTapAdvance.vue"
export default component.exports